var _currencyFormatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: "USD" });

window.addEventListener("load", function () {
     window.scrollReveal = new scrollReveal({ reset: true, move: '20px' });


     document.documentElement.addEventListener("click", function (e) {
        if (document.querySelector(".facet-sort-by-pc")) {
            let open_sort_by = Boolean(document.querySelector(".facet-sort-by-pc").getAttribute("aria-expanded") == "true");
            if (!e.target.closest(".facet-sort-by-pc") && open_sort_by) {
                document.querySelector(".facet-sort-by-pc").querySelector("summary").click();
            }
        }
        
     })
    // let _currencyFormatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active });

    $(".custom-sub-product-quantity").blur(function () {
        const $this = $(this);
        const $form = $this.parents("form");
        const $estimatedWrapper = $form.find(".custom-sub-product-estimated-wrapper");
        let price = $this.data("price") * 1;
        const quantity = $this.val();
        const estimatedMethod = $form.find(".custom-sub-product-estimated-input").val();
        const max = $this.data("max") * 1;
        const drawer = $form.find(`#${$this.data("drawerid")}`)
        const status = drawer.find(".custom-delivery-date-wrapper3").attr("data-status")
        let price_break_config = $this.data("pricebreaks") || null;
        if (price_break_config) {
            let price_break_list = price_break_config.split(",");
            for (let price_break of price_break_list) {
                let price_break_quantity= Number(price_break.split("-")[0]);
                let price_break_price = Number(price_break.split("-")[1]);
                if (quantity >= price_break_quantity) {
                    price = price_break_price;
                    $form.find(".custom-sub-product-price>span").html(_currencyFormatter.format(price / 100));
                    let coe = Number($form.find(".custom-sub-product-price-coe").data("coe"));
                    $form.find(".custom-sub-product-price-coe>span").html(_currencyFormatter.format(price / coe / 100));
                }
            }
        }

        const totalPrice = price * quantity;

        $form.find(".custom-sub-product-price-total").html(_currencyFormatter.format(totalPrice / 100));

        
        if (quantity < 1) {
            $this.val(1);
        }
        if(quantity > max){
            drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-num").html(max)
            if (max > 1) {
                drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-unit").html("items")
            }else{
                drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-unit").html("item")
            }
            drawer.find(".delivery-drawer-preOrder-public").removeClass("d-none")
            drawer.find(".delivery-drawer-preOrder-public").find(".custom-sub-product-estimated-num").html(quantity - max)
             if (quantity - max > 1) {
                drawer.find(".delivery-drawer-preOrder-public").find(".custom-sub-product-estimated-unit").html("items")
            }else{
                drawer.find(".delivery-drawer-preOrder-public").find(".custom-sub-product-estimated-unit").html("item")
            }
        }else{
            drawer.find(".delivery-drawer-preOrder-public").addClass("d-none")
            drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-num").html(quantity)
            if (quantity > 1) {
                drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-unit").html("items")
            }else{
                drawer.find(".delivery-drawer-inStock-public").find(".custom-sub-product-estimated-unit").html("item")
            }
        }
        if (status != "nomal") {
            drawer.find(".delivery-drawer-test3-inStock").addClass("d-none")
            drawer.find(".delivery-drawer-test3-preOrder").removeClass("d-none")
            drawer.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-num").html(quantity)
             if (quantity > 1) {
                drawer.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-unit").html("items")
            }else{
                drawer.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-unit").html("item")
            }
        }
        drawer.find(".delivery-drawer-preOrder-all-public").find(".custom-sub-product-estimated-num").html(quantity)
        if (quantity > 1) {
            drawer.find(".delivery-drawer-preOrder-all-public").find(".custom-sub-product-estimated-unit").html("items")
        }else{
            drawer.find(".delivery-drawer-preOrder-all-public").find(".custom-sub-product-estimated-unit").html("item")
        }
        const $inStock = $estimatedWrapper.find(".custom-sub-product-estimated-inStock");
        const $preOrder = $estimatedWrapper.find(".custom-sub-product-estimated-preOrder");
        
        if (estimatedMethod == "Ship as Available") {
            if(max <= 0){
                $inStock.addClass("d-none");
                $preOrder.find(".custom-sub-product-estimated-num").html(quantity);
                  if (quantity > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.removeClass("d-none");
            }else if (quantity > max) {
                $inStock.find("button").removeClass("d-none");
                $inStock.removeClass("d-none");
                $inStock.find(".custom-sub-product-estimated-num").html(max);
                $preOrder.find(".custom-sub-product-estimated-num").html(quantity - max);
                if (max > 1) {
                    $inStock.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $inStock.find(".custom-sub-product-estimated-unit").html("item")
                }
                if (quantity - max > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.removeClass("d-none");
            } else {
                $inStock.find("button").addClass("d-none");
                $inStock.find(".custom-sub-product-estimated-num").html(quantity);
                 if (quantity > 1) {
                    $inStock.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $inStock.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.addClass("d-none");
            }
        } else if(estimatedMethod == "Ship in Full") {
            $inStock.addClass("d-none");
            $preOrder.find(".custom-sub-product-estimated-num").html(quantity);
             if (quantity > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
            $preOrder.removeClass("d-none");
        }else{
            if(status != "nomal"){
                $inStock.addClass("d-none");
                $preOrder.find(".custom-sub-product-estimated-num").html(quantity);
                  if (quantity > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.removeClass("d-none");
            }else{
                $inStock.removeClass("d-none");
                if (quantity > max) {
                    $inStock.find(".custom-sub-product-estimated-num").html(max);
                    $preOrder.find(".custom-sub-product-estimated-num").html(quantity - max);
                    if (max > 1) {
                        $inStock.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $inStock.find(".custom-sub-product-estimated-unit").html("item")
                    }
                   if (quantity - max > 1) {
                        $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.removeClass("d-none");
                } else {
                    $inStock.find(".custom-sub-product-estimated-num").html(quantity);
                      if (quantity > 1) {
                        $inStock.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $inStock.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.addClass("d-none");
                }
            }
        }
    });
    $(".custom-sub-products-collapse-all").click(function () {
        if ($(this).hasClass("open")) {
            $(this).find("span").text("Expand All")
            $(this).removeClass("open")
            $(this).parents(".custom-sub-products-section").find("details").each((index, element) => {
                if ($(element).attr("aria-expanded") == 'true') {
                    $(element).find("summary").click()
                }
            });
        }else{
            $(this).find("span").text("Collapse All")
            $(this).addClass("open")
            $(this).parents(".custom-sub-products-section").find("details").each((index, element) => {
                if ($(element).attr("aria-expanded") == 'false') {
                    $(element).find("summary").click()
                }
            });
        }
    })
    
    $(".delivery-method-drawer-content").find("button[type='submit']").click(function () {
        const $this = $(this);
        const $drawerRadios = $this.siblings(".delivery-method-radio");
        const input_target = $drawerRadios.find(".estimated-radio").data("input");
        const $form = $(`#${input_target}`).parents("form")
        const val = $drawerRadios.find(".estimated-radio:checked").val();
        const diffDays =$(".custom-sub-products-section").data("diffdate") * 1
        const estimatedMethod = $form.find(".custom-sub-product-estimated-input").val();
        const currentDate = new Date();
        const targetDate = new Date();
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        $this.attr("aria-busy", "true");
        setTimeout(() => {
            $(`#${input_target}`).val(val);
            // const target = new Date(2026, 3, 20);
            // const today = new Date();
            // today.setHours(0, 0, 0, 0);
            // const new_diffMs = target - today; 
            // const new_diffDays = Math.ceil(new_diffMs / (1000 * 60 * 60 * 24));
            const new_diffDays = "50";
            if (val == "Delivery") {
                targetDate.setDate(currentDate.getDate() + diffDays);
                const formattedDate = targetDate.toLocaleDateString('en-GB', options).replace(/ /g, ' ');
                $form.find(".custom-delivery-method").text("delivery")
                $form.find(".custom-estimated-inStock-date").text(formattedDate)
                $form.find(".custom-sub-product-method-value").text(val)
                if(estimatedMethod == "Ship as Available"){
                    $form.find(".custom-subProduct-diffDays").val(diffDays);
                } else if (estimatedMethod == "Ship in Full"){
                	$form.find(".custom-subProduct-diffDays").val(new_diffDays);
                }
            }else{
                targetDate.setDate(currentDate.getDate() + diffDays - 1);
                const formattedDate = targetDate.toLocaleDateString('en-GB', options).replace(/ /g, ' ');
                $form.find(".custom-delivery-method").text("pickup")
                $form.find(".custom-estimated-inStock-date").text(formattedDate)
                $form.find(".custom-sub-product-method-value").text(val)
                if(estimatedMethod == "Ship as Available"){
                    $form.find(".custom-subProduct-diffDays").val(diffDays - 1);
                } else if (estimatedMethod == "Ship in Full"){
                	$form.find(".custom-subProduct-diffDays").val(new_diffDays);
                }
            }
            $this.siblings(".estimated-close").click();
            $this.removeAttr("aria-busy");
        }, 800);
    })
    $(".delivery-drawer-content").find("button[type='submit']").click(function () {
        const $this = $(this);
        const $drawerRadios = $this.siblings(".delivery-drawer-radios");
        const $customDeliveryQuantity = $this.siblings(".custom-delivery-quantity");
        const input_target = $drawerRadios.find(".estimated-radio").data("input");
        const $form = $(`#${input_target}`).parents("form")
        const method = $form.find(".custom-sub-product-method").val();
        const val = $drawerRadios.find(".estimated-radio:checked").val();
        const diffDays =$this.data("diffdate") * 1
        const max_quantity = $customDeliveryQuantity.data("inven") * 1;
        const target_input = $customDeliveryQuantity.data("id");
        const current_quantity = $(`#${target_input}`).val();
        const status = $drawerRadios.find(".custom-delivery-date-wrapper3").attr("data-status")
        const $inStock = $form.find(".custom-sub-product-estimated-inStock");
        const $preOrder = $form.find(".custom-sub-product-estimated-preOrder");
        $this.attr("aria-busy", "true");
        setTimeout(() => {
            $(`#${input_target}`).val(val);
            if (val === 'Ship as Available') {
                $inStock.removeClass("d-none");
                $inStock.find(".custom-sub-product-estimated-date").html($drawerRadios.find(".custom-delivery-date-wrapper3").attr("data-default"));
                if (current_quantity > max_quantity) {
                    $inStock.find(".custom-sub-product-estimated-num").html(max_quantity);
                    $preOrder.find(".custom-sub-product-estimated-num").html(current_quantity - max_quantity);
                    if (max_quantity > 1) {
                        $inStock.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $inStock.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    if (current_quantity - max_quantity > 1) {
                        $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.removeClass("d-none");
                } else {
                    $inStock.find(".custom-sub-product-estimated-num").html(current_quantity);
                      if (current_quantity > 1) {
                        $inStock.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $inStock.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.addClass("d-none");
                }
                if(method == "Delivery"){
                    $form.find(".custom-subProduct-diffDays").val(diffDays);
                }else if(method == "Pick Up"){
                    $form.find(".custom-subProduct-diffDays").val(diffDays - 1);
                }
            } else if (val === 'Ship in Full') {
                $inStock.addClass("d-none");
                $preOrder.find(".custom-sub-product-estimated-num").html(current_quantity);
                if (current_quantity > 1) {
                    $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                }else{
                    $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                }
                $preOrder.removeClass("d-none");
                // const target = new Date(2026, 3, 20);
                // const today = new Date();
                // today.setHours(0, 0, 0, 0);
                // const new_diffMs = target - today; 
                // const new_diffDays = Math.ceil(new_diffMs / (1000 * 60 * 60 * 24));
                // $form.find(".custom-subProduct-diffDays").val(new_diffDays);
                $form.find(".custom-subProduct-diffDays").val("50");
            } else {
                let instockDate = $drawerRadios.find(".custom-delivery-date-wrapper3").attr("data-stock")
                let preOrderDate = $drawerRadios.find(".custom-delivery-date-wrapper3").attr("data-preorder")
                if(status != "nomal"){
                    $inStock.addClass("d-none");
                    $preOrder.find(".custom-sub-product-estimated-num").html(current_quantity);
                    if (current_quantity > 1) {
                        $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                    }else{
                        $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                    }
                    $preOrder.removeClass("d-none");
                    $preOrder.find(".custom-sub-product-estimated-date").text(preOrderDate)
                }else{
                    if (instockDate != "") {
                        $inStock.find(".custom-sub-product-estimated-date").html(instockDate);
                    }
                    if (preOrderDate != "") {
                        $preOrder.find(".custom-sub-product-estimated-date").html(preOrderDate);
                    }
                    $inStock.removeClass("d-none");
                    if (current_quantity > max_quantity) {
                        $inStock.find(".custom-sub-product-estimated-num").html(max_quantity);
                        $preOrder.find(".custom-sub-product-estimated-num").html(current_quantity - max_quantity);
                        if (max_quantity > 1) {
                            $inStock.find(".custom-sub-product-estimated-unit").html("items")
                        }else{
                            $inStock.find(".custom-sub-product-estimated-unit").html("item")
                        }
                        if (current_quantity - max_quantity > 1) {
                            $preOrder.find(".custom-sub-product-estimated-unit").html("items")
                        }else{
                            $preOrder.find(".custom-sub-product-estimated-unit").html("item")
                        }
                        $preOrder.removeClass("d-none");
                    } else {
                        $inStock.find(".custom-sub-product-estimated-num").html(current_quantity);
                        if (current_quantity > 1) {
                            $inStock.find(".custom-sub-product-estimated-unit").html("items")
                        }else{
                            $inStock.find(".custom-sub-product-estimated-unit").html("item")
                        }
                        $preOrder.addClass("d-none");
                    }
                }
            }
            $this.siblings(".estimated-close").click();
            $this.removeAttr("aria-busy");
        }, 800);
    });
    $(".sample_fieldset").find("select").change(function () {
        let $form = $(this).parents("form");
        let price = $(this).find("option:selected").data("price");
        let max = $(this).find("option:selected").data("max");
        let current_sku = $(this).find("option:selected").data("sku");
        let quantity = $form.find(".sample_quantity").val();
        $form.find(".sample_total_price").html(_currencyFormatter.format((price * quantity) / 100));
        $form.find(".sample_quantity").attr("max", max);
        $form.find(".sample_quantity").attr("data-sku", current_sku);
        $form.find(".sample_quantity_error").find("span").html(max);
        $form.find(".sample_quantity_free_tip").find("span").html(max);

        if (quantity > max) {
            $form.find(".sample_quantity_error").fadeIn();
            $form.find(".sample_product_button").find("button:not(._disabled)").attr("disabled", true);
        }else{
            $form.find(".sample_quantity_error").fadeOut();
            $form.find(".sample_product_button").find("button:not(._disabled)").removeAttr("disabled");
        }
        if(price == 0){
            $form.find(".sample_quantity_free_tip").show();
        }else{
            $form.find(".sample_quantity_free_tip").hide();
        }
    });
    $(".sample_fieldset").find(".sample_quantity").change(function () {
        let $form = $(this).parents("form");
        let price = $form.find("select").find("option:selected").data("price");
        let max = $(this).attr("max") * 1;
        let quantity = $(this).val() * 1;
        $form.find(".sample_total_price").html(_currencyFormatter.format((price * quantity) / 100));
        if (quantity > max) {
            $form.find(".sample_quantity_error").fadeIn();
            $form.find(".sample_product_button").find("button:not(._disabled)").attr("disabled", true);
        }else{
            $form.find(".sample_quantity_error").fadeOut();
            $form.find(".sample_product_button").find("button:not(._disabled)").removeAttr("disabled");
        }
    });

    // custom-register
    $("#custom-register-another-checkbox").change(function () {
        const $this = $(this);
        const $form = $this.parents("form");
        if ($this.is(":checked")) {
            $form.find(".custom-register-another-address").removeClass("d-none");
        } else {
            $form.find(".custom-register-another-address").addClass("d-none");
        }
    })
    
})

function custom_click(id,max,in_stock_day,pre_order_day) {
    const date = new Date();
    const current_year = date.getFullYear();
    const current_month = String(date.getMonth() + 1).padStart(2, '0');
    const current_day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${current_year}-${current_month}-${current_day}`;
    window.open_date = true
    jeDate(`#${id}`, {
        trigger: false,
        minDate: formattedDate,
        format: 'YYYY-MM-DD',
        onClose: false,
        isClear: false,
        isToday: false,
        isYes: false,
        donefun:function(a){
            let selected_date = new Date(a.val)
            let in_stock_date = new Date(in_stock_day)
            let pre_order_date = new Date(pre_order_day)
            let $box = $(a.elem).parents(".delivery-drawer-radios")
            const quantity = $box.find(".delivery-drawer-preOrder-all-public").find(".custom-sub-product-estimated-num").html() * 1
            let max_quantity = max * 1
            const selected_day = selected_date.getDate();
            const selected_month = selected_date.toLocaleString('en-us', { month: 'short' }); 
            const selected_year = selected_date.getFullYear();
            const selected_date_format = `${selected_day} ${selected_month} ${selected_year}`
            const preOrder_day = pre_order_date.getDate();
            const preOrder_month = pre_order_date.toLocaleString('en-us', { month: 'short' }); 
            const preOrder_year = pre_order_date.getFullYear();
            const preOrder_date_format = `${preOrder_day} ${preOrder_month} ${preOrder_year}`
            
            const default_date_format = $box.find(".custom-delivery-date-wrapper3").attr("data-default")
            if (selected_date <= in_stock_date) {
                $box.find(".custom-delivery-date-wrapper3").attr("data-stock", default_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-preorder",preOrder_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-status",'nomal')
                $box.find(".delivery-drawer-test3-inStock").removeClass("d-none")
                $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-date").text(default_date_format)
                $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-date").text(preOrder_date_format)
                if(quantity > max_quantity ){
                    $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-num").html(max_quantity)
                    $box.find(".delivery-drawer-test3-preOrder").removeClass("d-none")
                    $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-num").html(quantity - max_quantity)
                }else{
                    $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-num").html(quantity)
                    $box.find(".delivery-drawer-test3-preOrder").addClass("d-none")
                }
            }else if(selected_date > in_stock_date && selected_date <= pre_order_date){
                $box.find(".custom-delivery-date-wrapper3").attr("data-stock",selected_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-preorder",preOrder_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-status",'nomal')
                $box.find(".delivery-drawer-test3-inStock").removeClass("d-none")
                $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-date").text(selected_date_format)
                $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-date").text(preOrder_date_format)
                if(quantity > max_quantity ){
                    $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-num").html(max_quantity)
                    $box.find(".delivery-drawer-test3-preOrder").removeClass("d-none")
                    $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-num").html(quantity - max_quantity)
                }else{
                    $box.find(".delivery-drawer-test3-inStock").find(".custom-sub-product-estimated-num").html(quantity)
                    $box.find(".delivery-drawer-test3-preOrder").addClass("d-none")
                }
            }else{
                $box.find(".custom-delivery-date-wrapper3").attr("data-stock","")
                $box.find(".custom-delivery-date-wrapper3").attr("data-preorder",selected_date_format)
                $box.find(".delivery-drawer-test3-inStock").addClass("d-none")
                $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-num").html(quantity)
                $box.find(".delivery-drawer-test3-preOrder").removeClass("d-none")
                $box.find(".delivery-drawer-test3-preOrder").find(".custom-sub-product-estimated-date").text(selected_date_format)
                $box.find(".custom-delivery-date-wrapper3").attr("data-status",'timeOut')
            }
        }
    })
}

// await fetch(`${window.Shopify.routes.root}?section_id=${extractSectionId(this)}`)

var CustomVariantList = class extends HTMLElement {
    constructor() {
        super();
        this.section_id = this.getAttribute("data-id")
        this.items = this.querySelectorAll(".custom-variant-item")
        
        this.items.forEach((item) => {
            item.addEventListener("click", this.handleItemClick.bind(this));
        });
        this.variants = JSON.parse(this.querySelector("script[data-variants]")?.textContent || "{}")
        this.currentVariant = JSON.parse(this.querySelector("script[data-current-variant]")?.textContent || "{}")
        document.addEventListener("variant:change", (event) => {
            this.setVariantById(event.detail.variant.id);
        });
    }
    setVariantById(variantId) {
        const target = [...this.items].find(
            el => el.dataset.variantId == variantId
        );
        if (!target) return;
        this.items.forEach(el => el.classList.remove("active"));
        target.classList.add("active");
    }
    handleItemClick(event) {
        const item = event.currentTarget;
        const variantId = item.dataset.variantId;
        
        const variant = this.variants.find(
            v => v.id === Number(variantId)
        )
       
        this.setVariant(variant)
    }
    setVariant(variant) {
        
        const options = [
            variant.option1,
            variant.option2,
            variant.option3
        ].filter(Boolean);

        options.forEach((value, index) => {
            const input = document.querySelector(
            `input[data-option-position="${index + 1}"][data-option="${value}"]`
            );
            if (input) input.checked = true;
        });
        const last = options.length;

        const trigger = document.querySelector(
            `input[data-option-position="${last}"][data-option="${options[last - 1]}"]`
        );
        
        trigger?.dispatchEvent(new Event("change", { bubbles: true }));
        }
};
if (!window.customElements.get("custom-variant-list")) {
  window.customElements.define("custom-variant-list", CustomVariantList);
}

var CustomProductFeatures = class extends HTMLElement {
    constructor() {
        super();
        this.variants = JSON.parse(this.querySelector("script[data-variant-info]")?.textContent || "{}")
        this.wrapper = this.querySelector(".custom-product-features-items")
        document.addEventListener("variant:change", (event) => {
            this.updateInfo(event.detail.variant)
        });
    }
   
    updateInfo(current_variant) {
        
        const variant = this.variants.data.find(
            v => v.sku === current_variant.sku
        )
        
        let html = ``;
        html = `
        <div class="custom-product-features-item">
            <div class="custom-product-features-item-key">SKU</div>
            <div class="custom-product-features-item-value">${current_variant.sku}</div>
        </div>
        `
        if (variant) {
            variant.list.forEach((item) => {
                html += `
                <div class="custom-product-features-item">
                    <div class="custom-product-features-item-key">${item.key}</div>
                    <div class="custom-product-features-item-value">${item.value}</div>
                </div>
                `;
            });
        }
       
        this.wrapper.innerHTML = html;
    }
};
if (!window.customElements.get("custom-product-features")) {
  window.customElements.define("custom-product-features", CustomProductFeatures);
}

class customIntroduceColl extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".custom-introduce-coll-icon")
    this.wrapper = this.querySelector(".custom-introduce-coll-content")
  }
connectedCallback() {
    if (!this.button || !this.wrapper) return;
    
    this.button.addEventListener("click", () => {
      this.toggle();
    });
  }
    toggle() {
        const isOpen = this.classList.contains("open");
        console.log(this);

        if (isOpen) {
            $(this.wrapper).slideUp()
        this.classList.remove("open");
        } else {
            $(this.wrapper).slideDown()
        this.classList.add("open");
        }
    }
}
if (!window.customElements.get("custom-introduce-coll")) {
customElements.define('custom-introduce-coll', customIntroduceColl);
}


class customJeDate extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input")
  }
connectedCallback() {
    this.addEventListener("click", () => {
      this.toggle();
    });
  }
    toggle() {
        const date = new Date();
        const current_year = date.getFullYear();
        const current_month = String(date.getMonth() + 1).padStart(2, '0');
        const current_day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${current_year}-${current_month}-${current_day}`;
        window.open_date = true
        jeDate(this.input, {
            trigger: false,
            minDate: formattedDate,
            format: 'YYYY-MM-DD',
            onClose: false,
            isClear: false,
            isToday: false,
            isYes: false,
            disabledDate:["2026/9/25","2026/11/3","2026/12/19", "2026/12/20", "2026/12/21", "2026/12/22", "2026/12/23","2026/12/24", "2026/12/25", "2026/12/26", "2026/12/27", "2026/12/28",  "2026/12/29", "2026/12/30", "2026/12/31", "2027/1/1",  "2027/1/2", "2027/1/3", "2027/1/4","2027/1/5", "2027/1/6","2027/1/7","2027/1/8","2027/1/9","2027/1/10","2027/1/26","2027/3/8","2027/3/26","2027/3/27","2027/3/28","2027/3/29","2027/4/25","2027/6/14","2027/9/24","2027/11/2"],
            donefun:function(a){
                console.log(a)
            }
        })
    }
}
if (!window.customElements.get("custom-je-date")) {
    customElements.define('custom-je-date', customJeDate);
}
class customStripe extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input")
        this.btn = this.querySelector("button")
        this.id = this.getAttribute("data-id")
    }
    connectedCallback() {
        this.getStatus()
        this.btn.addEventListener("click", () => {
            this.submit();
        });
    }
    getStatus(){
        const params = new URLSearchParams({
            "shopify_gid": this.id,
            "page": 1,
            "page_size":10
        });
        let needPolling = false;
        let url = `https://knox-corporation-sh.odoo.com/api/credit/payment/stripe/records?${params.toString()}`
        fetch(url)
            .then(response => {
                if (!response.ok) {
                throw new Error(`HTTP 错误！状态码: ${response.status}`);
                }
                return response.json(); 
            })
            .then(data => {
                let data_list = data.data.items
                const trHtmlList = data.data.items.map(item => {
                    const date = item.created_at.split(' ')[0];
                    const state = item.state
                    let msg = ""
                    if (state === "paid") {
                    } else if (["draft", "pending", "processing"].includes(state)) {
                        msg = "Payment is awaiting confirmation."; 
                        needPolling = true;
                    } else if (
                        state === "failed" &&
                        ["accounting_sync_failed", "accounting_post_failed"].includes(error_code)
                    ) {
                        msg = "Your payment has been received, but we're still processing it in our system. Please contact us if you need assistance..";
                    } else {
                        msg = "Payment was not completed. You can try again."; 
                    }
                    return `
                        <tr>
                            <td>${date}</td>
                            <td>$${item.amount}</td>
                            <td>${item.state}</td>
                            <td>${msg}</td>
                        </tr>
                    `;
                    }).join('');
                    const tbody = this.querySelector('tbody');
                    if (tbody) {
                        tbody.innerHTML = trHtmlList;
                    }
                    if (needPolling) {
                        if (this.pollTimer) clearTimeout(this.pollTimer);
                        this.pollTimer = setTimeout(() => {
                            this.getStatus();
                        }, 2000);
                    }
            })
            .catch(error => {
                console.error("请求发生错误：", error);
            });
    }
    submit() {
        let repayment = this.input.value
        this.btn.setAttribute("aria-busy","true")
        let uuid = crypto.randomUUID()
        let data = {
            "shopify_gid": `gid://shopify/Company/${this.id}`,
            "amount": repayment,
            "currency": "AUD",
            "client_request_id": uuid
        }
        let url =  "https://knox-corporation-sh.odoo.com/api/credit/payment/stripe/create_checkout_session"
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then((res) => {
            console.log(res);
            
            if (!res.ok) throw new Error("Network response was not ok");
            return res.json(); 
        })
        .then((response) => {
        this.btn.setAttribute("aria-busy","false")
            
            if(response.success && response.data.checkout_url){
               location.href = response.data.checkout_url;
            }
        })
    }
}
if (!window.customElements.get("custom-stripe")) {
    customElements.define('custom-stripe', customStripe);
}
class customAccountBalance extends HTMLElement {
  constructor() {
    super();
        this.id = this.getAttribute("data-id")
        if (this.id) {
            this.initBalance()
        }
    }

    initBalance() {
        let url = `https://knox-corporation-sh.odoo.com/api/shopify/${this.id}/credit_info`
        fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
            },
        })
        .then((res) => {
            if (!res.ok) throw new Error("Network response was not ok");
            return res.json(); 
        })
        .then((response) => {
            if(response.success){
                let html = `
                    <div class="account-profile-container account-profile-container-balance-wrapper">
                    <div class="account-profile-item">
                        <div class="account-profile-item-label">Current Balance</div>
                        <div class="account-profile-item-info">
                        <div class="account-profile-item-balance-item">
                            <div>Credit Limit</div>
                            <div>${response.data.credit_limit}</div>
                        </div>
                        <div class="account-profile-item-balance-item">
                            <div>Available Credit</div>
                            <div>${response.data.credit_available}</div>
                        </div>
                        </div>
                    </div>
                    <div class="account-profile-item">
                        <div class="account-profile-item-label">Outstanding</div>
                        <div class="account-profile-item-info">
                            <div class="account-profile-item-balance-item">
                            <div>Current</div>
                            <div>${response.data.outstanding.current}</div>
                            </div>
                                ${
                                response.data.outstanding.overdue_now > 0
                                ? `
                                <div class="account-profile-item-balance-item" style="color:#FF0000;">
                                <div>Overdue Now</div>
                                <div>${response.data.outstanding.overdue_now}</div>
                                </div>
                                `
                                : ''
                            }
                            <div class="account-profile-item-balance-item">
                            <div>Total Balance Due</div>
                            <div>${response.data.outstanding.total_balance_due}</div>
                            </div>
                        </div>
                    </div>
                </div>
                `
                this.innerHTML += html;
            }
        })
       
    }
}
if (!window.customElements.get("custom-account-balance")) {
    customElements.define('custom-account-balance', customAccountBalance);
}

class customTab extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll(".tab-button"));
        this.contents = Array.from(this.querySelectorAll(".tab-content"));

        this.addEventListener("click", (e) => {
            const btn = e.target.closest(".tab-button");
            if (!btn) return;
            
            const index = this.buttons.indexOf(btn);
            if (index !== -1) {
                this.toggle(index);
            }
        });
    }
    toggle(index) {
        this.buttons.forEach((btn, i) => {
            btn.classList.toggle("active", i === index);
        });
        this.contents.forEach((content, i) => {
            content.classList.toggle("active", i === index);
            if(i === index && content.querySelector("custom-swiper")){
                content.querySelector("custom-swiper").initSwiper()
            }
        });
    } 
   
}
if (!window.customElements.get("custom-tab")) {
    customElements.define('custom-tab', customTab);
}

class CustomSwiper extends HTMLElement {
    constructor() {
        super(),
        this.slidesPerView_pc = Number(this.getAttribute("data-row")) || "auto",
        this.slidesPerView_m = Number(this.getAttribute("data-rowm")) || "auto",
        this.has_button = this.getAttribute("data-button") == "true",
        this.has_pagination = this.getAttribute("data-pagination") == "true"
        this.loop = this.getAttribute("data-loop") == "true"
        this.autoplay = this.getAttribute("data-autoplay") == "true"
        this.speed = this.getAttribute("data-speed") * 1000 || 3000
        this.swiperInstance = null;
    }
    connectedCallback() {
        setTimeout( () => this.initSwiper(), 0)
    }
    initSwiper() {
        if (this.swiperInstance) {
            this.swiperInstance.update();
            return;
        }
        const nextEl = this.querySelector(".swiper-button-next")
          , prevEl = this.querySelector(".swiper-button-prev")
          , pagination = this.querySelector(".swiper-pagination")
          , swiperContainer = this.querySelector(".custom-swiper-container") || this
          , config = {
            slidesPerView: this.slidesPerView_m,
            spaceBetween: 10,
            freeMode: false,
            loop:this.loop,
            breakpoints: {
                700: {
                    slidesPerView: this.slidesPerView_pc,
                    spaceBetween: 20
                }
            }
        };
        this.has_button && nextEl && prevEl && (config.navigation = {
            nextEl,
            prevEl
        }),
        this.autoplay && (config.autoplay = {
            delay:this.speed
        })
        this.has_pagination && pagination && (config.pagination = {
            el: pagination
        }),
        this.swiperInstance = new Swiper(swiperContainer,config)

    }
}
if (!window.customElements.get("custom-swiper")) {
customElements.define("custom-swiper", CustomSwiper);
}
class customCreditInfo extends HTMLElement {
  constructor() {
    super();
        this.id = this.getAttribute("data-id")
        this.amount_wrapper = this.querySelector(".knoxone-credit__amount")
        this.credit_limit_wrapper = this.querySelector(".knoxone-credit__stat-value")
        this.balance_owing_wrapper = this.querySelector(".knoxone-balance-owing-account")
        this.overdue_wrapper = this.querySelector(".knoxone-overdue-account")
        this.fill_wrapper = this.querySelector(".knoxone-credit__progress-fill")
        this.usage_percent_wrapper = this.querySelector(".knoxone-credit__usage-percent")
        this.used_wrapper = this.querySelector(".knoxone-credit__legend-used-value")
        this.available_wrapper = this.querySelector(".knoxone-credit__legend-available-value")
        
        if (this.id) {
            this.initBalance()
        }
    }

    initBalance() {
        let url = `https://knox-corporation-sh.odoo.com/api/shopify/${this.id}/credit_info`
        fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
            },
        })
        .then((res) => {
            if (!res.ok) throw new Error("Network response was not ok");
            return res.json(); 
        })
        .then((response) => {
            if(response.success){
                console.log(response);
                this.amount_wrapper.innerHTML = "$"+response.data.credit_available
                this.credit_limit_wrapper.innerHTML = "$"+response.data.credit_limit
                this.balance_owing_wrapper.innerHTML = "$"+response.data.outstanding.total_balance_due
                this.overdue_wrapper.innerHTML = "$"+response.data.outstanding.overdue_now
                let available_percent = ((response.data.credit_available * 100) / response.data.credit_limit).toFixed(2);
                let used_percent = (100 - available_percent).toFixed(2);
                this.fill_wrapper.style.width = used_percent + '%'
                this.usage_percent_wrapper.innerHTML = used_percent + '%'
                this.used_wrapper.innerHTML = "$" + response.data.outstanding.total_balance_due + " (" + used_percent + '%)'
                this.available_wrapper.innerHTML = "$" + response.data.credit_available + " (" + available_percent + '%)'

            }
        })
       
    }
}
if (!window.customElements.get("custom-credit-info")) {
    customElements.define('custom-credit-info', customCreditInfo);
}

class customCreditStripe extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input")
        this.btn = this.querySelector("button")
        this.id = this.getAttribute("data-id")
    }
    connectedCallback() {
        this.getStatus()
        this.btn.addEventListener("click", () => {
            this.submit();
        });
    }
    getStatus(){
        const params = new URLSearchParams({
            "shopify_gid": this.id,
            "page": 1,
            "page_size":10
        });
        let needPolling = false;
        let url = `https://knox-corporation-sh.odoo.com/api/credit/payment/stripe/records?${params.toString()}`
        fetch(url)
            .then(response => {
                if (!response.ok) {
                throw new Error(`HTTP 错误！状态码: ${response.status}`);
                }
                return response.json(); 
            })
            .then(data => {
                let data_list = data.data.items
                if (data_list.length > 0) {
                    this.querySelector(".knoxone-credit__history").removeAttribute("hidden")
                }
                const trHtmlList = data.data.items.map(item => {
                    const date = item.created_at.split(' ')[0];
                    const state = item.state
                    let msg = ""
                    if (state === "paid") {
                    } else if (["draft", "pending", "processing"].includes(state)) {
                        msg = "Payment is awaiting confirmation."; 
                        needPolling = true;
                    } else if (
                        state === "failed" &&
                        ["accounting_sync_failed", "accounting_post_failed"].includes(error_code)
                    ) {
                        msg = "Your payment has been received, but we're still processing it in our system. Please contact us if you need assistance..";
                    } else {
                        msg = "Payment was not completed. You can try again."; 
                    }
                    return `
                        <tr>
                            <td>${date}</td>
                            <td>$${item.amount}</td>
                            <td>${item.state}</td>
                            <td>${msg}</td>
                        </tr>
                    `;
                    }).join('');
                    const tbody = this.querySelector('tbody');
                    if (tbody) {
                        tbody.innerHTML = trHtmlList;
                    }
                    if (needPolling) {
                        if (this.pollTimer) clearTimeout(this.pollTimer);
                        this.pollTimer = setTimeout(() => {
                            this.getStatus();
                        }, 2000);
                    }
            })
            .catch(error => {
                console.error("请求发生错误：", error);
            });
    }
    submit() {
        let repayment = this.input.value
        this.btn.setAttribute("aria-busy","true")
        let uuid = crypto.randomUUID()
        let data = {
            "shopify_gid": `gid://shopify/Company/${this.id}`,
            "amount": repayment,
            "currency": "AUD",
            "client_request_id": uuid
        }
        let url =  "https://knox-corporation-sh.odoo.com/api/credit/payment/stripe/create_checkout_session"
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then((res) => {
            console.log(res);
            
            if (!res.ok) throw new Error("Network response was not ok");
            return res.json(); 
        })
        .then((response) => {
        this.btn.setAttribute("aria-busy","false")
            
            if(response.success && response.data.checkout_url){
               location.href = response.data.checkout_url;
            }
        })
    }
}
if (!window.customElements.get("custom-credit-stripe")) {
    customElements.define('custom-credit-stripe', customCreditStripe);
}


class customReturnLink extends HTMLElement {
  constructor() {
    super();
        
    }

    connectedCallback() {
        const link = this.querySelector('a');
        if (!link) return;

        const currentPath = window.location.pathname + window.location.search;

        const originalHref = link.getAttribute('href') || '/customer_authentication/login';
        const baseUrl = originalHref.split('?')[0];
        link.setAttribute('href', `${baseUrl}?return_to=${encodeURIComponent(currentPath)}`);
    }
}
if (!window.customElements.get("custom-return-link")) {
    customElements.define('custom-return-link', customReturnLink);
}
class customBreakQuantity extends HTMLElement {
  constructor() {
    super();
         this.input = this.querySelector('input[type="number"]');
        if (!this.input) return;
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.input.addEventListener('input', this.handleQuantityChange);
        this.input.addEventListener('change', this.handleQuantityChange);
        this.priceDom = this.closest("form").querySelector(".custom-total-price")
        this.updatePrice();
    }
    disconnectedCallback() {
        this.input?.removeEventListener('input', this.handleQuantityChange);
        this.input?.removeEventListener('change', this.handleQuantityChange);
    }
    getUnitPrice(quantity) {
        const defaultPrice = Number(this.input.dataset.price) || 0;
        const priceBreaks = this.input.dataset.pricebreaks;

        if (!priceBreaks) return defaultPrice;

        const rules = priceBreaks
        .split(',')
        .map((item) => {
            const [minQuantity, price] = item.trim().split('-').map(Number);

            return { minQuantity, price };
        })
        .filter((rule) => Number.isFinite(rule.minQuantity) && Number.isFinite(rule.price))
        .sort((a, b) => a.minQuantity - b.minQuantity);

        const matchedRule = rules
        .filter((rule) => quantity >= rule.minQuantity)
        .at(-1);

        return matchedRule ? matchedRule.price : defaultPrice;
    }

    updatePrice() {
        const quantity = Number(this.input.value) || 0;
        const unitPrice = this.getUnitPrice(quantity);
        const totalPrice = quantity * unitPrice;
        this.priceDom.innerHTML = _currencyFormatter.format(totalPrice / 100)
    }

    handleQuantityChange() {
        this.updatePrice();
    }
}
if (!window.customElements.get("custom-break-quantity ")) {
    customElements.define('custom-break-quantity', customBreakQuantity);
}


// let url =  "https://knox-corporation-sh.odoo.com/api/shopify/companies/overdue"
//         fetch(url, {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//             }
//         })
//         .then((res) => {
//             console.log(res);
            
//             if (!res.ok) throw new Error("Network response was not ok");
//             return res.json(); 
//         })
//         .then((response) => {
//                 console.log(response);
//                 let data = response.data
//                 for (const element of data) {
//                     let id = element.company_id
//                     fetch(`https://knox-corporation-sh.odoo.com/api/shopify/${id}/credit_info`, {
//                         method: 'GET',
//                         headers: {
//                             'Content-Type': 'application/json',
//                     },
//                     })
//                     .then((res1) => {
//                         if (!res1.ok) throw new Error("Network response was not ok");
//                         return res1.json(); 
//                     })
//                     .then((response1) => {
//                         console.log(response1);
//                     })
//                 }
                
           
//         })